import React, { useMemo } from 'react';
import { TABLE_COLUMNS } from '../constants';
import MaterialTableActions from '../components/MaterialTableActions';
import MaterialStatus from '../components/MaterialStatus';

export const useTableColumns = (
  materials,
  handleViewDetails,
  onPassMaterial,
  handleFinishMaterial,
  inverseLogisticP
) => {
  return useMemo(() => [
    {
      title: 'Material',
      field: TABLE_COLUMNS.MATERIAL,
      sorting: false,
      hidden: false,
    },
    {
      title: `MAPE (${inverseLogisticP(materials[0]?.porc_mape_norm_eq).toFixed(2)}%)`,
      field: TABLE_COLUMNS.MAPE,
      render: (rowData) => {
        const value = (rowData.porc_mape * 100).toFixed(2);
        const threshold = inverseLogisticP(materials[0]?.porc_mape_norm_eq).toFixed(2);
        return (
          <p style={{ color: threshold < Math.abs(value) ? "red" : "black" }}>
            {value}%
          </p>
        );
      },
      sorting: false,
      hidden: false,
    },
    {
      title: `BIAS (${inverseLogisticP(materials[0]?.porc_bias_norm_eq).toFixed(2)}%)`,
      field: TABLE_COLUMNS.BIAS,
      render: (rowData) => {
        const value = (rowData.porc_bias * 100).toFixed(2);
        const threshold = inverseLogisticP(materials[0]?.porc_bias_norm_eq).toFixed(2);
        return (
          <p style={{ color: threshold < Math.abs(value) ? "red" : "black" }}>
            {value}%
          </p>
        );
      },
      sorting: false,
      hidden: false,
    },
    {
      title: `Var Costo (${inverseLogisticP(materials[0]?.porc_cambio_costo_norm_eq).toFixed(2)}%)`,
      field: TABLE_COLUMNS.VAR_COSTO,
      render: (rowData) => {
        const value = (rowData.por_cambio_costo * 100).toFixed(2);
        const threshold = inverseLogisticP(materials[0]?.porc_cambio_costo_norm_eq).toFixed(2);
        return (
          <p style={{ color: threshold < Math.abs(value) ? "red" : "black" }}>
            {value}%
          </p>
        );
      },
      sorting: false,
      hidden: false,
    },
    {
      title: `Agotados (${inverseLogisticP(materials[0]?.porc_disponibilidad_norm_eq).toFixed(2)}%)`,
      field: TABLE_COLUMNS.AGOTADOS,
      render: (rowData) => {
        const value = (rowData.porc_disponibilidad * 100).toFixed(2);
        const threshold = inverseLogisticP(materials[0]?.porc_disponibilidad_norm_eq).toFixed(2);
        return (
          <p style={{ color: threshold < Math.abs(value) ? "red" : "black" }}>
            {value}%
          </p>
        );
      },
      sorting: false,
      hidden: false,
    },
    {
      title: 'Descripción',
      field: TABLE_COLUMNS.DESCRIPCION,
      sorting: false,
      hidden: false,
    },
    {
      title: 'Category',
      field: TABLE_COLUMNS.CATEGORY,
      sorting: false,
    },
    {
      title: 'Ped L3M',
      field: TABLE_COLUMNS.PED_L3M,
    },
    {
      title: 'Presupuesto',
      field: TABLE_COLUMNS.PRESUPUESTO,
    },
    {
      title: 'Categoría',
      field: TABLE_COLUMNS.CATEGORIA,
      sorting: false,
    },
    {
      title: 'Marca',
      field: TABLE_COLUMNS.MARCA,
      sorting: false,
    },
    {
      title: 'Familia',
      field: TABLE_COLUMNS.FAMILIA,
      sorting: false,
    },
    {
      title: 'Clasificación',
      field: TABLE_COLUMNS.CLASIFICACION,
      sorting: false,
    },
    {
      title: 'Baseline',
      field: TABLE_COLUMNS.BASELINE,
      sorting: false,
    },
    {
      title: 'Delta',
      field: TABLE_COLUMNS.DELTA,
      sorting: false,
    },
    {
      title: 'Eventos',
      field: TABLE_COLUMNS.EVENTOS,
      sorting: false,
    },
    {
      title: 'Comprable',
      field: TABLE_COLUMNS.COMPRABLE,
      render: (rowData) => (rowData.estado ? 'Si' : 'No'),
      sorting: false,
    },
    {
      title: 'Tipo',
      field: TABLE_COLUMNS.TIPO,
      render: (rowData) => (rowData.obligatorio ? 'Obligatorio' : 'Opcional'),
      sorting: false,
    },
    {
      title: 'Acciones',
      field: 'estado',
      render: (rowData) => (
        <MaterialTableActions
          rowData={rowData}
          handleViewDetails={handleViewDetails}
          onPassMaterial={onPassMaterial}
          handleFinishMaterial={handleFinishMaterial}
        />
      ),
      sorting: false,
    },
    {
      title: 'Estado     ',
      field: 'fc',
      render: (rowData) => (
        <MaterialStatus fc={rowData.fc} fg={rowData.fg} />
      ),
      sorting: false,
    },
  ], [materials, handleViewDetails, onPassMaterial, handleFinishMaterial, inverseLogisticP]);
};
